export default __webpack_public_path__ + "static/media/chapterWebsite5Low.4823dc26.jpg";